/**
 * Public-site theme toggle (light ↔ dark).
 * Cookie: theme=light|dark|system; Path=/; Max-Age=1y; SameSite=Lax (+ Secure on https).
 * Default (no cookie): system — follows prefers-color-scheme until the user toggles manually.
 */
(function () {
  'use strict';

  var COOKIE = 'theme';
  var MAX_AGE = 31536000;
  var THEME_COLORS = { light: '#1B4332', dark: '#101614' };
  var LOGO_LIGHT_DEFAULT = '/img/logo/logo-primary-black.png';
  var LOGO_DARK_DEFAULT = '/img/logo/logo-primary-white.png';

  function readCookie(name) {
    var match = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[1]) : '';
  }

  function writeCookie(value) {
    var parts = [
      COOKIE + '=' + encodeURIComponent(value),
      'Path=/',
      'Max-Age=' + MAX_AGE,
      'SameSite=Lax',
    ];
    if (location.protocol === 'https:') {
      parts.push('Secure');
    }
    document.cookie = parts.join('; ');
  }

  function normalize(raw) {
    if (!raw) return 'system';
    var v = String(raw).toLowerCase();
    if (v === 'dark' || v === 'light' || v === 'system') return v;
    return 'system';
  }

  function systemPrefersDark() {
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
  }

  function resolveTheme(preference) {
    if (preference === 'system') {
      return systemPrefersDark() ? 'dark' : 'light';
    }
    return preference === 'dark' ? 'dark' : 'light';
  }

  function nextPreference(currentTheme) {
    return currentTheme === 'dark' ? 'light' : 'dark';
  }

  function setMetaThemeColor(theme) {
    var meta = document.querySelector('meta[name="theme-color"]');
    if (!meta) return;
    meta.setAttribute('content', THEME_COLORS[theme] || THEME_COLORS.light);
  }

  function swapLogos(theme) {
    var logos = document.querySelectorAll('.site-logo');
    for (var i = 0; i < logos.length; i++) {
      var img = logos[i];
      if (img.classList.contains('site-logo--footer')) continue;
      var light = img.getAttribute('data-logo-light') || LOGO_LIGHT_DEFAULT;
      var dark = img.getAttribute('data-logo-dark') || LOGO_DARK_DEFAULT;
      img.setAttribute('src', theme === 'dark' ? dark : light);
    }
  }

  function updateToggles(theme) {
    var pressed = theme === 'dark';
    var label = pressed ? 'Switch to light mode' : 'Switch to dark mode';
    var toggles = document.querySelectorAll('[data-theme-toggle]');
    for (var i = 0; i < toggles.length; i++) {
      var btn = toggles[i];
      btn.setAttribute('aria-pressed', pressed ? 'true' : 'false');
      btn.setAttribute('aria-label', label);
      btn.setAttribute('title', label);
    }
  }

  function applyTheme(preference) {
    var pref = normalize(preference);
    var theme = resolveTheme(pref);
    document.documentElement.dataset.theme = theme;
    writeCookie(pref === 'system' ? 'system' : theme);
    setMetaThemeColor(theme);
    swapLogos(theme);
    updateToggles(theme);
    return theme;
  }

  function onToggleClick(e) {
    var btn = e.target.closest && e.target.closest('[data-theme-toggle]');
    if (!btn) return;
    e.preventDefault();
    var current = document.documentElement.dataset.theme || resolveTheme(normalize(readCookie(COOKIE)));
    applyTheme(nextPreference(current));
  }

  function watchSystemTheme() {
    if (!window.matchMedia) return;
    var mq = window.matchMedia('(prefers-color-scheme: dark)');
    var onChange = function () {
      if (normalize(readCookie(COOKIE)) === 'system') {
        applyTheme('system');
      }
    };
    if (mq.addEventListener) {
      mq.addEventListener('change', onChange);
    } else if (mq.addListener) {
      mq.addListener(onChange);
    }
  }

  function init() {
    document.addEventListener('click', onToggleClick);
    watchSystemTheme();
    var preference = normalize(readCookie(COOKIE) || 'system');
    // Re-sync from cookie in case HTML was cached without matching cookie
    applyTheme(preference);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
